export enum CompaniesEnum {
    CGOS = 'cgos',
    CGOSAURA = 'cgosaura',
    CGOSPACA = 'cgospaca',
    CGOSNORMANDIE = 'cgosnormandie',
    YOONLYLAPLAGNE = 'yoonlylaplagne',
    AIRFRANCE = 'airfrance',
    SOFINCO = 'sofinco',
    MACIF = 'macif',
    ORANO = 'orano',
    GROUPE_UNEO = 'groupe-uneo',
    MERCEDESTRUCK = 'mercedestruck',
    C1CE = 'c1ce',
    MACIFAVANTAGES = 'macifavantages',
    VYV_AVANTAGES = 'vyv-avantages',
    VEEPEE = 'veepee',
    ADECCO = 'adecco',
    COSOG = 'cosog',
    CGOSPM = 'CGOSPM',
    PRIMOLOISIRS = 'primoloisirs',
    ALLIANCEPOLICE = 'alliancepolice',
    FNACDARTY = 'fnacdarty',
    BNPPF = 'bnppf',
    WIISMILE = 'wiismile',
    CNRS = 'cnrs',
    BOURSORAMA = 'boursorama',
    SYNERGIE = 'synergie',
    CSECATALOGUE = 'csecatalogue',
    PASSEMONTAGNE = 'passemontagne',
    CSEE_SG = 'csee-sg',
    PARCASTERIX = 'parcasterix',
    MERCEDES = 'mercedes',
    SNCF = 'sncf',
    CEZAM = 'cezam',
    SFR = 'sfr'
}

export enum CgosCompaniesEnum {
    CGOS = CompaniesEnum.CGOS,
    CGOSAURA = CompaniesEnum.CGOSAURA,
    CGOSPACA = CompaniesEnum.CGOSPACA,
    CGOSPM = CompaniesEnum.CGOSPM,
    CGOSNORMANDIE = CompaniesEnum.CGOSNORMANDIE
}
